


















































import { Vue, Component, PropSync } from 'vue-property-decorator';
import ThirtyDaysNoticeViewModel from '@/vue-app/view-models/components/flagship/flagship-link-goals/thirthy-days-notice/thirty-days-notice-view-model';

@Component({ name: 'ThirtyDaysNotice' })
export default class ThirtyDaysNotice extends Vue {
  @PropSync('isOpen', { type: Boolean, required: true })
  is_open!: boolean;

  @PropSync('elapsedDays', { type: Number, required: true })
  elapsed_days!: number;

  view_model = Vue.observable(new ThirtyDaysNoticeViewModel(this))

  closeDialog() {
    this.is_open = false;
  }

  accept() {
    this.view_model.accept();
    this.closeDialog();
  }
}
